import { visserApi } from "./visserApi";
const getAllArticals = async () => {
    return visserApi.get('Article/GetArticleDropdown');
};
const getArticleById = (articleId) => {
    return visserApi.get(`Article/GetArticleById/${articleId}`);
};
const getWorkOrdersListWithClientAsync = async (workOrderNumber) => {
    return await visserApi.get(`Workorder/GetSearchableWorkOrdersList/${workOrderNumber}`);
};
const CreatePurchaseInvoiceLine = (purchaseInvoiceLineDto) => {
    return visserApi.post('PurchaseInvoiceLine/Create', purchaseInvoiceLineDto);
};
const getAllPurchaseInvoiceLinesById = (purchaseInvoiceId) => {
    return visserApi.get(`PurchaseInvoiceLine/GetAllPurchaseInvoiceLinesById/${purchaseInvoiceId}`);
};
const getPurchaseInvoiceLineById = (Id) => {
    return visserApi.get(`PurchaseInvoiceLine/GetPurchaseInvoiceLineByID/${Id}`);
};
const UpdatePurchaseInvoiceLine = (Id, purchaseInvoiceLineDto) => {
    return visserApi.put(`PurchaseInvoiceLine/Update/${Id}`, purchaseInvoiceLineDto);
};
const deletePurchaseInvoiceLine = async (id) => {
    return await visserApi.delete(`PurchaseInvoiceLine/Delete/${id}`);
};
const PurchaseInvoiceLineApi = {
    getAllArticals,
    getArticleById,
    getWorkOrdersListWithClientAsync,
    CreatePurchaseInvoiceLine,
    getAllPurchaseInvoiceLinesById,
    getPurchaseInvoiceLineById,
    UpdatePurchaseInvoiceLine,
    deletePurchaseInvoiceLine
};
export default PurchaseInvoiceLineApi;
